// Single source of truth for Ichimoku component colors. Consumed by:
//   - IndicatorControls legend dot (must match the chart series color)
//   - CandlestickChart series colors (Tenkan, Kijun, Chikou LineSeries)
//   - IchimokuCloudPrimitive bullish/bearish fill
//
// bullishCloud and bearishCloud must differ in luminance, not just hue, so the
// signal carries under common color-vision deficiencies (REQ-006).

export const LUMINANCE_DELTA_THRESHOLD = 0.25;

export const ichimokuPalette = {
  tenkan: '#2962ff',
  kijun: '#e91e63',
  chikou: '#f9a825',
  spanA: '#26a69a',
  spanB: '#ef5350',
  bullishCloud: 'rgba(38, 200, 50, 0.30)',
  bearishCloud: 'rgba(180, 30, 30, 0.30)',
} as const;

export type IchimokuPalette = typeof ichimokuPalette;
